
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.229 6.616l1.796-3.243a1.601 1.601 0 00-.55-2.114 1.42 1.42 0 00-2.011.524l-1.748 3.155c-1.86-.608-3.814-.174-4.565 1.181L7.276 9.503c-.83 1.498-2.433 3.042-3.439 3.928-.527.465-.89.748-.89.748l2.467 1.116 1.5-.53v1.588L10.71 19s2.811-1.936 4.33-4.676l1.874-3.384c.703-1.268.435-2.989-.685-4.324zm-1.59-1.283a5.696 5.696 0 01.848.56l1.689-3.047a.54.54 0 00-.185-.712.478.478 0 00-.678.176l-1.675 3.023zm-9.181 8.83l2.456-.867v2.487l2.774 1.934c.258-.205.591-.484.959-.824.727-.674 1.557-1.56 2.208-2.57l-.06-.067c-.15-.17-.369-.409-.632-.678-.532-.541-1.232-1.19-1.94-1.662-.703-.469-1.536-.828-2.206-1.071a14.4 14.4 0 00-1.12-.355l-.015-.004H7.88l.004-.017c-.718 1.134-1.74 2.216-2.576 3.014-.152.146-.3.284-.441.413l.592.267zm8.418-1.285c.196.2.367.383.508.537l1.667-3.01c.555-1.001.219-2.844-1.61-3.98-.894-.555-1.902-.767-2.753-.678-.868.09-1.429.465-1.674.908L8.388 9.588l.09.026c.219.065.525.162.88.291.705.256 1.622.647 2.42 1.179.791.528 1.548 1.233 2.098 1.794zM6.091 3.74l2.151 2.214-2.09 2.277L4 6.017 6.091 3.74zm.02 1.497l-.697.76.717.737.697-.76-.717-.737zm.131 3.893l-2.15-2.214L2 9.193l2.151 2.214L6.242 9.13zm-2.828.042l.697-.759.717.738-.697.76-.717-.739z","fill":"#303133"}})])
          )
        }
      }
    